<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.applicationType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['applyType',{'initialValue':'50'}]" :trigger-change="true" dictCode="sqlx" placeholder="请选择申请类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item  :label="$t('label.businessType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag   type="list" v-decorator="['subType',validatorRules.subType]" :trigger-change="true" dictCode="deposit_type" :placeholder="$t('label.pleaseSelectBusinessType')"  @change="handoverMethodChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.documentDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectDocumentDate')" v-decorator="['postDate',{'initialValue': initPostDate, rules: validatorRules.postDate.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag   type="list" v-decorator="['farmerCode',validatorRules.farmerCode]" :trigger-change="true" dict="efs_md_farmer,CONCAT(code((comma))((verticalLine))((comma))name),code,del_flag='N'" :placeholder="$t('label.pleaseSelectFarms')" @change="handleContractChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.contractID')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['contractCode',validatorRules.contractCode]"
                :trigger-change="true"
                :dictCode="dictContractCode"
                :placeholder="$t('label.pleaseSelectContract')"
                @change="breedBatchCodeChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  type="list"  v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" :trigger-change="true" :dictCode="dictBreedBatchCode" :placeholder="$t('label.pleaseSelectTheFeedingLot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.method')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag   type="list" v-decorator="['handoverMethod',validatorRules.handoverMethod]" :trigger-change="true" :dictCode="dictHandoverMethod" :placeholder="$t('label.pleaseSelectMethod')" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['applyAmount',validatorRules.applyAmount]" :placeholder="$t('label.pleaseInputTheApplicationAmount')"  style="width: 100%" @change="applyAmountChange"/>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item  v-has="'notes'" :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['notes']" rows="4" :placeholder="$t('label.pleaseEnterANote')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import moment from "moment";
  import { getCurrentUser } from '@api/api'

  export default {
    name: 'EfsStlSettleApplyForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
            subType: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectBusinessType')},
                ]
            },
            breedBatchCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectTheFeedingLot')},
                ]
            },
            farmerCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectGrower')},
                ]
            },
            handoverMethod: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectMethod')},
                ]
            },
            postDate: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectTheDateOfRecording')},
                ]
            },
            contractCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectContract')},
                ]
            },
            applyAmount: {
                rules: [
                    { required: true, message: this.$t('label.pleaseEnterTheAmount')},
                ]
            },
        },
        url: {
          add: "/depositManage/efsStlSettleApply/add",
          edit: "/depositManage/efsStlSettleApply/edit",
          queryById: "/depositManage/efsStlSettleApply/queryById",
          queryBySupporterAmount: "/depositManage/efsStlSettleApply/queryBySupporterAmount",
          queryByContractAmount: "/depositManage/efsStlSettleApply/queryByContractAmount"
        },
          dictFarmerCode:"",
          dictBreedBatchCode:"",
          dictContractCode:"",
          dictHandoverMethod:"",
          initApplyUser: null,
          initPostDate: moment(new Date()).format('YYYY-MM-DD'),
          initDocDate: moment(new Date()).format('YYYY-MM-DD'),
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.initApplyUser = res.result.username;
            }
        });
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
          if(this.model.id){
              this.dictContractCode="efs_md_contract,code,code, pb_farmer_code = '" + this.model.farmerCode + "' and del_flag = 'N' and approval_status='30'";
              this.dictBreedBatchCode="efs_md_contract,breed_batch_code,breed_batch_code, code = '" + this.model.contractCode + "' and del_flag = 'N' and approval_status='30'";
              this.dictHandoverMethod="sys_dict_item,item_text,item_value, dict_id = (SELECT id FROM sys_dict WHERE dict_code='handover_method')";
          }else {
              this.model.contractCode='';
              this.model.breedBatchCode='';
              this.model.handoverMethod='';
              this.model.applyAmount=0;
          }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'subType','farmCode','breedBatchCode','contractCode','farmerCode','applyType','planBreedQty','applyAmount','bankAccount','postDate','peasant','applicant','applyTime','lastApprover','lastApproveTime','validFlag','notes','handoverMethod'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'subType','farmCode','breedBatchCode','contractCode','farmerCode','applyType','planBreedQty','applyAmount','bankAccount','postDate','peasant','applicant','applyTime','lastApprover','lastApproveTime','validFlag','notes','handoverMethod'))
      },

        handleContractChange(value) {
            this.dictContractCode="efs_md_contract,code,code, pb_farmer_code = '" + value + "' and del_flag = 'N' and approval_status='30'";
            this.model.contractCode = '';
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'contractCode'))
            })
        },
        breedBatchCodeChange(value) {
            //this.dictBreedBatchCode="efs_md_contract,breed_batch_code,breed_batch_code, code = '" + value + "' and del_flag = 'N' and approval_status='30'";
            this.dictBreedBatchCode="efs_md_breed_batch,code,code, con_code = '" + value + "' and del_flag = 'N'";
            this.model.breedBatchCode = '';
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'breedBatchCode'))
            })
        },
        applyAmountChange(value){
          //业务类型领用
          let subType=this.form.getFieldsValue(['subType']).subType;
          //养户
          let farmerCode=this.form.getFieldsValue(['farmerCode']).farmerCode;
          //合同编号
          let contractCode=this.form.getFieldsValue(['contractCode']).contractCode;
          if(subType==30){
              let params = {farmerCode:farmerCode};
              let amount=0;
              getAction(this.url.queryBySupporterAmount,params).then((res)=>{
                  if(res.success){
                      if(res.result.marginAmount){
                          amount=res.result.marginAmount;
                          if(Number(value)>Number(amount)){
                              this.model.applyAmount = 0;
                              this.$message.warning("余额不足");
                          }else{
                              this.model.applyAmount = value;
                          }
                      }
                  }
              });
          }else if(subType==20){
              let params = {contractCode:contractCode};
              let amount=0;
              getAction(this.url.queryByContractAmount,params).then((res)=>{
                  if(res.success){
                      if(res.result.balance){
                          amount=res.result.balance;
                          if(Number(value)>Number(amount)){
                              this.model.applyAmount = 0;
                              this.$message.warning("余额不足");
                          }else{
                              this.model.applyAmount = value;
                          }
                      }

                  }
              });
          }else{
              this.model.applyAmount=value;
          }
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'applyAmount'))
            })
        },
        handoverMethodChange(value){
            if(value==30){
                this.dictHandoverMethod="sys_dict_item,item_text,item_value, dict_id = (SELECT id FROM sys_dict WHERE dict_code='handover_method') and item_value in (30)";
            }else{
                this.dictHandoverMethod="sys_dict_item,item_text,item_value, dict_id = (SELECT id FROM sys_dict WHERE dict_code='handover_method') and item_value not in (30)";
            }
            this.model.handoverMethod = '';
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'handoverMethod'))
            })

        }
    }
  }
</script>